import { AdminSidebar } from './AdminSidebar';
import { AgentTopNav } from './AgentTopNav';
import { useAuth } from '../../lib/auth';

export const DashboardLayout = ({ children, title }) => {
  const { isAdmin, isStaff } = useAuth();
  
  // Agents use top navigation, Admin/Staff use sidebar
  const useTopNav = !isAdmin() && !isStaff();

  if (useTopNav) {
    // Agent Layout with Top Navigation
    return (
      <div className="min-h-screen bg-slate-50">
        <AgentTopNav />
        <main className="min-h-screen">
          {title && (
            <div className="bg-white border-b border-slate-100 px-4 sm:px-8 py-4 sm:py-6">
              <div className="max-w-7xl mx-auto">
                <h1 className="text-xl sm:text-2xl font-bold text-slate-900">{title}</h1>
              </div>
            </div>
          )}
          <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6 sm:py-8">
            {children}
          </div>
        </main>
      </div>
    );
  }

  // Admin/Staff Layout with Sidebar
  return (
    <div className="min-h-screen bg-slate-50">
      <AdminSidebar />
      <main className="ml-64 min-h-screen">
        {title && (
          <div className="bg-white border-b border-slate-100 px-8 py-6">
            <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
          </div>
        )}
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
